let Wrapper = (props) => props.children;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/Hoc/Wrapper.js